import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const error = params.error;
      if (error) {
        console.log('Linkedin authorization failed!');
      }

      const linkedinCallbackCode = params.code;
      this.authService.getLinkedinToken(linkedinCallbackCode).subscribe(resLinkedinToken => {
        if (resLinkedinToken) {
          window.location.href = 'http://localhost:4300/helpdesk/settings/omni-channel?success=true';
        } else {
          window.location.href = 'http://localhost:4300/helpdesk/settings/omni-channel?success=false';
        }
      }, (resError) => {
        console.log(resError);
        window.location.href = 'http://localhost:4300/helpdesk/settings/omni-channel?success=false';
      });
    });
  }

}
